import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";


export class OrganizationsAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  createSuccess() {
    const message = {
      body: 'ORGANIZATION_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message);
  };

  createError() {
    const message = {
      body: 'ORGANIZATION_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess(organization) {
    const message = {
      body: 'X_ORGANIZATION_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message, organization)
  }

  updateError() {
    const message = {
      body: 'ORGANIZATION_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteSuccess(organization) {
    const message = {
      body: 'X_ORGANIZATION_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message, organization)
  }

  deleteError() {
    const message = {
      body: 'ORGANIZATION_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


}

angular
  .module('bringoz.admin.organizations')
  .service('organizationsAlertsService', OrganizationsAlertsService);
